import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type GetWorkflowRuleDefinitionsQueryVariables = GraphQLTypes.Exact<{
  filter?: GraphQLTypes.InputMaybe<GraphQLTypes.WorkflowRulesDefinitionFilterInput>;
}>;

export type GetWorkflowRuleDefinitionsQueryResult = { __typename?: 'Query' } & {
  workflowRuleDefinitions: Array<
    GraphQLTypes.Maybe<
      { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
        GraphQLTypes.WorkflowRuleDefinitionType,
        'id' | 'ruleDefinitionTag' | 'ruleDescription' | 'ruleName'
      > & {
          ruleInputFields: Array<
            { __typename?: 'WorkflowRuleFieldType' } & Pick<
              GraphQLTypes.WorkflowRuleFieldType,
              'component' | 'hidden' | 'label' | 'name' | 'required'
            >
          >;
          ruleOutputFields: Array<
            { __typename?: 'WorkflowRuleFieldType' } & Pick<
              GraphQLTypes.WorkflowRuleFieldType,
              'component' | 'hidden' | 'label' | 'name' | 'required'
            >
          >;
        }
    >
  >;
};

export const GetWorkflowRuleDefinitionsDocument = /*#__PURE__*/ gql`
  query getWorkflowRuleDefinitions($filter: WorkflowRulesDefinitionFilterInput) {
    workflowRuleDefinitions(filter: $filter) {
      id
      ruleDefinitionTag
      ruleDescription
      ruleInputFields {
        component
        hidden
        label
        name
        required
      }
      ruleName
      ruleOutputFields {
        component
        hidden
        label
        name
        required
      }
    }
  }
`;

/**
 * __useGetWorkflowRuleDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowRuleDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowRuleDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowRuleDefinitionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetWorkflowRuleDefinitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetWorkflowRuleDefinitionsQueryResult, GetWorkflowRuleDefinitionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<GetWorkflowRuleDefinitionsQueryResult, GetWorkflowRuleDefinitionsQueryVariables>(
    GetWorkflowRuleDefinitionsDocument,
    options
  );
}
export function useGetWorkflowRuleDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowRuleDefinitionsQueryResult, GetWorkflowRuleDefinitionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<GetWorkflowRuleDefinitionsQueryResult, GetWorkflowRuleDefinitionsQueryVariables>(
    GetWorkflowRuleDefinitionsDocument,
    options
  );
}
export type GetWorkflowRuleDefinitionsQueryHookResult = ReturnType<typeof useGetWorkflowRuleDefinitionsQuery>;
export type GetWorkflowRuleDefinitionsLazyQueryHookResult = ReturnType<typeof useGetWorkflowRuleDefinitionsLazyQuery>;
